
$('.collection-slider').slick({
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1124,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

const showNewsletterCheck = getCookie('showNewsletter');


if(!showNewsletterCheck) {
const newsletterPopup = document.querySelector(".newsletter-popup");

const showNewsLetter = document.querySelector('#show_newsletter');

if(newsletterPopup) {
  
  if(showNewsLetter) {
    showNewsLetter.addEventListener('input', () => {
        if(showNewsLetter.checked) {
			setCookie('showNewsletter','true',7);
        } else {
			eraseCookie('showNewsletter')
        }
	}); 
  }
  const popupCLoser = newsletterPopup.querySelector('.popup-closer');
  
  popupCLoser.addEventListener('click', () => {
  	newsletterPopup.parentElement.classList.remove('active');                       
  })
  window.addEventListener('load', () => {
    setTimeout(() => {
		newsletterPopup.parentElement.classList.add('active');
  	}, 2500);
  });
}
}

const unavailiablePopup = document.querySelector(".unavailable-popup");

if(unavailiablePopup) {
  const popupCLoser = unavailiablePopup.querySelector('.popup-closer');
  const buttonunvailable = document.querySelector('.button-unavailable');
  
  popupCLoser.addEventListener('click', () => {
  	unavailiablePopup.classList.remove('active');                       
  })
  
  buttonunvailable.addEventListener('click', () => {
  	unavailiablePopup.classList.add('active');                       
  })
  
}